import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicTax({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M11.8.6c.61 0 .95.73.56 1.2l-2.17 2.61c.82.5 1.44.93 1.87 1.28a.73.73 0 11-.93 1.14 18.5 18.5 0 00-1.99-1.34H5.61l-.28.16c-2.6 1.46-3.86 3.28-3.86 5.47 0 1.56 2.06 2.7 5.92 2.7a10 10 0 004.48-.83.73.73 0 01.67 1.3c-1.25.65-3 .99-5.15.99-4.57 0-7.39-1.56-7.39-4.16C0 8.35 1.56 6.1 4.57 4.39L2.42 1.8A.73.73 0 012.98.6zM7.1 7.55c.27 0 .5.22.5.5v.2a.5.5 0 01-.5.5h-.92v3.18a.5.5 0 01-.5.5h-.41a.5.5 0 01-.5-.5V8.75h-.92a.5.5 0 01-.5-.5v-.2c0-.28.22-.5.5-.5H7.1zm2.51 0c.21 0 .4.13.47.33l1.45 3.98 1.3-1.98-1.12-1.68a.42.42 0 01.35-.65h.5a.5.5 0 01.43.23l.7 1.1.69-1.1a.5.5 0 01.42-.23h.5a.42.42 0 01.35.65l-1.07 1.68 1.2 1.9a.43.43 0 01-.36.65h-.5a.5.5 0 01-.42-.23l-.82-1.3-.82 1.3a.5.5 0 01-.42.23h-1.78a.5.5 0 01-.48-.34l-.27-.78H8.6l-.27.78a.5.5 0 01-.48.34h-.37a.5.5 0 01-.47-.67l1.41-3.88a.5.5 0 01.47-.33h.73zm-.36 1.74l-.29.84h.58l-.3-.84zm.97-7.22H4.55L6 3.8c.06.07.1.14.13.22h2.53a.73.73 0 01.13-.22l1.44-1.73z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgBasicTax.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicTax.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgBasicTax svgRef={ref} {...props} />);
export default ForwardRef;
